export default __webpack_public_path__ + "static/silka-regular-webfont-d4a02e221a18b839b37d50ad9c9e7705.woff";